type Props = { url: string; onClose: () => void };

export default function IframeModal({ url, onClose }: Props) {
  return (
    <div
      className="absolute inset-0 z-[60]"
      style={{
        background: "rgba(0,0,0,.55)",
        animation: "fadeIn .18s ease-out",
      }}
    >
      <div
        className="absolute left-1/2 top-1/2"
        style={{
          transform: "translate(-50%, -50%)",
          width: "min(90vw, 1280px)",
          height: "min(90vh, 900px)",
          borderRadius: 18,
          overflow: "hidden",
          background: "rgba(10,10,10,0.9)",
          border: "1px solid rgba(255,255,255,.10)",
          boxShadow: "0 24px 80px rgba(0,0,0,.45)",
          backdropFilter: "blur(4px)",
          animation: "popIn .18s ease-out",
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            right: 10,
            top: 10,
            zIndex: 2,
            border: "1px solid rgba(255,255,255,.15)",
            background: "rgba(0,0,0,.6)",
            color: "#fff",
            borderRadius: 999,
            padding: "8px 12px",
            cursor: "pointer",
          }}
          aria-label="Cerrar"
          title="Cerrar"
        >
          ✕
        </button>
        <iframe
          src={url}
          title="Estación"
          style={{ border: "none", width: "100%", height: "100%" }}
          allow="clipboard-read; clipboard-write"
          allowFullScreen
        />
      </div>
    </div>
  );
}
